import { render, staticRenderFns } from "./el-input.vue?vue&type=template&id=521f462a&scoped=true"
import script from "./el-input.vue?vue&type=script&lang=js"
export * from "./el-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f462a",
  null
  
)

export default component.exports